import React from 'react';
import { COM_DATA, RECEIVER_ACTIONS, SENDER_ACTIONS, PAGE_CHANGE_REQUEST } from '../models/Engine';
import { PageType } from '../models/PageData';
import { LOG, LOG_TYPE } from '../models/Log';

const useMachineComs = () => {
  React.useEffect(() => {
    window.RECEIVER = (action: { type: RECEIVER_ACTIONS; payload: string | COM_DATA | PAGE_CHANGE_REQUEST }) => {
      switch (action.type) {
        case 'SET_DATA':
          window.DATA = action.payload as COM_DATA;
          break;
        case 'CHANGE_PAGE':
          const payload = action.payload as PAGE_CHANGE_REQUEST;
          document.dispatchEvent(
            new CustomEvent('CHANGE_PAGE', {
              bubbles: false,
              detail: payload,
            })
          );
          break;
        default:
          break;
      }
    };
    window.LOGGER = (action: { type: LOG_TYPE; payload: string }) => {
      if (window?.DATA?.deviceId) {
        const newEntry: LOG = {
          dateCreated: `${new Date().toISOString()}`,
          message: action.payload,
          type: action.type,
          experienceId: window?.DATA?.experienceId ?? '',
          serialNumber: window.DATA.deviceId,
        };
        window.SENDER({ type: SENDER_ACTIONS.POST_LOG, payload: JSON.stringify([newEntry]) });
      }
    };
    window.SENDER = (action: { type: SENDER_ACTIONS; payload: unknown }) => {
      window.chrome.webview.postMessage(action);
    };
    if (!window?.chrome?.webview?.postMessage) {
      initializeEmulator();
      window.RECEIVER({type: RECEIVER_ACTIONS.SET_DATA, payload: {deviceId: "EMULATOR", experienceId: "", isChannelsConfigured: true, isExperienceConfigured: true, products: null, inventory: null}})
    }
  }, []);
};

const emulateMachine = (action: { type: SENDER_ACTIONS; payload: unknown }) => {
  switch (action.type) {
    case SENDER_ACTIONS.VEND:
      window.RECEIVER({ type: RECEIVER_ACTIONS.CHANGE_PAGE, payload: { page: PageType.SCREEN_VENDING } });
      setTimeout(() => {
        const vendResponses = [PageType.SCREEN_PRODUCT_OUT_OF_STOCK, PageType.SCREEN_VEND_ERROR, PageType.SCREEN_VEND_SUCCESS];
        const randomResponse = vendResponses[Math.floor(Math.random() * vendResponses.length)];
        window.RECEIVER({ type: RECEIVER_ACTIONS.CHANGE_PAGE, payload: { page: randomResponse } });
      }, 5000);
      break;
    default:
      break;
  }
};

const initializeEmulator = () => {
  window.chrome = {
    webview: {
      postMessage: emulateMachine,
    },
  };
};

export default useMachineComs;
